import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

// Register required components
ChartJS.register(ArcElement, Tooltip, Legend);
const DoughnutChart = ({ donutValues = {} }) => {
  const values = {
    mcq: donutValues?.multiple_choice || 0,
    fib: donutValues?.fill_in_the_blanks || 0,
    short: donutValues?.short_answer || 0,
    assignment: donutValues?.assignment || 0,
    total_questions: donutValues?.total_question || 1, // Default to 1 to avoid division by zero
  };

  const percentageConversion = (value) => {
    return ((value / values.total_questions) * 100) || 0;
  };

  const data = {
    labels: ['Multiple Choice', 'Fill in the Blanks', 'Short Answer', 'Assignment'],
    datasets: [
      {
        data: [
          values.mcq,
          values.fib,
          values.short,
         values.assignment,
        ],
        backgroundColor: ['#42D4D9', '#FF6F91', '#3498DB', '#93DB34'], // Colors for each section
        hoverBackgroundColor: ['#34B9BF', '#FF4D70', '#277DCB', '#78C825'], // Colors on hover
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: '50%', // Makes the Doughnut chart "donut-shaped" by setting the inner radius
    plugins: {
      legend: {
        display: false, // Shows the legend
      },
      tooltip: {
        enabled: true, // Enables the tooltip
      },
    },
  };
  
  return <Doughnut data={data} options={options} />;
};

export default DoughnutChart;
